// Desktop Header Component
// Shared header for all desktop pages with navigation buttons

import React from 'react';
import { useNavigationManager } from '../../../managers/navigation-manager';
import { useAuth } from '../../../contexts/AuthContext';
import { envUtils } from '../../../core/utils';
import './DesktopHeader.css';

export function DesktopHeader({ activePage = 'settings' }) {
  const navigationManager = useNavigationManager();
  const { isAdmin, membershipDetails, user, isBetaTester } = useAuth();
  const isAdminForDesktopDevChat =
    !!isAdmin ||
    user?.role === 'admin' ||
    membershipDetails?.role === 'admin' ||
    membershipDetails?.role === 'site_admin';

  const handleNavigateToSettings = () => {
    navigationManager.navigateTo('desktop/settings');
  };

  const handleNavigateToModels = () => {
    navigationManager.navigateTo('desktop/models');
  };

  const handleNavigateToDevChat = () => {
    navigationManager.navigateTo('desktop/dev-chat');
  };

  const handleNavigateToTandem = () => {
    navigationManager.navigateTo('desktop/tandem');
  };

  return (
    <div className="desktop-header">
      <div className="desktop-header-content">
        {/* Desktop title with gradient and version badge */}
        <div className="desktop-header-title">
          <span className="desktop-header-logo-text">Revolt Desktop</span>
          {envUtils.device.isDesktopApp() && envUtils.device.getDesktopVersion() && (
            <span
              className="desktop-header-version-badge"
              aria-label={`Revolt Desktop version v${envUtils.device.getDesktopVersion()}`}
              title={`Revolt Desktop version v${envUtils.device.getDesktopVersion()}`}
            >
              v{envUtils.device.getDesktopVersion()}
            </span>
          )}
        </div>

        {/* Navigation buttons */}
        <div className="desktop-header-nav">
          <button
            className={`desktop-nav-button ${activePage === 'models' ? 'active' : ''}`}
            onClick={handleNavigateToModels}
          >
            <i className="fa-solid fa-brain"></i>
            <span>AI Models</span>
          </button>

          <button
            className={`desktop-nav-button ${activePage === 'settings' ? 'active' : ''}`}
            onClick={handleNavigateToSettings}
          >
            <i className="fa-solid fa-cog"></i>
            <span>Settings</span>
          </button>

          {isAdminForDesktopDevChat && (
            <button
              className={`desktop-nav-button ${activePage === 'dev-chat' ? 'active' : ''}`}
              onClick={handleNavigateToDevChat}
            >
              <i className="fa-solid fa-comments"></i>
              <span>Dev Chat</span>
            </button>
          )}

          {isBetaTester && (
            <button
              type="button"
              className={`desktop-nav-button ${activePage === 'tandem' ? 'active' : ''}`}
              onClick={handleNavigateToTandem}
            >
              <i className="fa-solid fa-diagram-project" aria-hidden />
              <span>Tandem</span>
            </button>
          )}

          {/* Future buttons can be added here */}
          {/* <button className="desktop-nav-button">
            <i className="fa-solid fa-download"></i>
            <span>Downloads</span>
          </button> */}
        </div>
      </div>
    </div>
  );
}